import React from 'react';
import { Flex, Text, TextButton } from '@amzn/storm-ui';
import { useSelector } from 'react-redux';
import { selectPageLayoutType } from 'src/app/slice';
import { DesktopToggleWrap, FooterLink, FooterWrapper } from './Footer.styles';
import { FooterComponentProps } from './Footer.types';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { toKebabCase } from 'src/commons/utils/helpers';
import { chromeComponents } from 'src/constants';

const Desktop: React.VFC<FooterComponentProps> = ({
  copyright,
  links,
  toggleText,
  toggleView,
  isFooterLinkEnabled,
}) => {
  const pageLayoutType = useSelector(selectPageLayoutType);

  return (
    <FooterWrapper id="footer" pageLayoutType={pageLayoutType}>
      {/* TODO: Remove the toggle button below */}
      {isFooterLinkEnabled && toggleText && toggleView && (
        <DesktopToggleWrap>
          <TextButton style={{ fontSize: '40px' }} onClick={toggleView}>
            {toggleText}
          </TextButton>
        </DesktopToggleWrap>
      )}
      <Flex alignItems="center" justifyContent="center" columnGap="base">
        <Text color="secondary" renderAs="span">
          {copyright}
        </Text>
        {links &&
          links.map((link) => (
            <FooterLink
              key={link.label}
              href={link.url}
              {...getTaktAttributes(
                link.id ?? toKebabCase(link.label),
                chromeComponents.FOOTER,
                { url: link.url },
              )}
            >
              {link.label}
            </FooterLink>
          ))}
      </Flex>
    </FooterWrapper>
  );
};

export default Desktop;
